import React, { useState, useEffect } from 'react';
import getProuduct from '../../api/details.api';
import visitorCount from '../../api/visitor.api';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import './Details.css'

const Details = () => {
    const { id } = useParams();
    const [productData, setProductData] = useState({})
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [mainPic, setMainPic] = useState('')
    const [description, setDesc] = useState([])

    useEffect(() => {
        getProduct()
    }, [])

    const getProduct = async () => {
        await getProuduct(id, setProductData, setError, setLoading, setDesc)
        await visitorCount()
    }

    const replaceImg = (value) => {
        setMainPic(value)
    }

    if (loading) return <div className='loader_container'><span className="loader"></span></div>
    if (error) return <div>error....</div>

    return (
        <div className='details'>
            <div className="details-container">
                <div className="product-img">
                    <img src={(mainPic == '') ? productData.product_images.mainPicURL : mainPic} alt="product_img" />
                    <div className="sub-product-img">
                        <img src={productData.product_images.mainPicURL} onClick={() => replaceImg(productData.product_images.mainPicURL)} alt="product_img" />
                        <img src={productData.product_images.PicURL1} onClick={() => replaceImg(productData.product_images.PicURL1)} alt="product_img" />
                        <img src={productData.product_images.PicURL2} onClick={() => replaceImg(productData.product_images.PicURL2)} alt="product_img" />
                        <img src={productData.product_images.PicURL3} onClick={() => replaceImg(productData.product_images.PicURL3)} alt="product_img" />
                    </div>
                </div>
                <div className='product-details'>
                    <p className='product-name-details'>{productData.product_name}</p>
                    <p className='product-code'>كود المنتج: <span>076bf11zn50</span></p>
                    <div className="product-price">
                        <p>{productData.product_price} <span>جنيه مصري</span></p>
                        <p className={`${(productData.product_price_offer) == 1 ? 'd-none' : null}`}>{`${productData.product_price_offer} جنيه مصري`}</p>
                    </div>
                    <div className="line"></div>
                    <p className='product-status'>حالة المنتج: {(productData.available) ? <span>متوفر</span> : <span>غير متوفر في المخزن</span>}</p>
                    <p className='product-desc'>تفاصيل المنتج</p>
                    {description.map(item => {
                        return (
                            <div key={item}>
                                <p className='desc_item'>● {item}.</p>
                            </div>
                        )
                    })}
                    <Link className={`${(productData.available) ? 'd-initail' : 'd-none'}`} to={`/order/${productData._id}/${productData.product_name}`}><button>اطلب الان</button></Link>
                    <button className={`${(!productData.available) ? 'd-initail' : 'd-none'} not_avilabel`}>لا يمكن طلب هذا المنتج لعدم توفرة</button>
                </div>
            </div>
        </div>
    );
}


export default Details;